import { render, staticRenderFns } from "./LessonVocabulary.vue?vue&type=template&id=e22e82bc&scoped=true"
import script from "./LessonVocabulary.vue?vue&type=script&lang=js"
export * from "./LessonVocabulary.vue?vue&type=script&lang=js"
import style0 from "./LessonVocabulary.vue?vue&type=style&index=0&id=e22e82bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22e82bc",
  null
  
)

export default component.exports